import { useTranslation } from 'react-i18next';
import closingImage from 'assets/images/accounting/finance-control.jpg';
import {
  CopyStack,
  Overline,
  SectionHeading,
  SectionInner,
  SplitImage,
  SplitRow,
  WhiteSection,
} from '../HostfullyAccountingMarketing.styles';
import ContactUsButton from '../components/ContactUsButton';

const ClosingSection = () => {
  const { t } = useTranslation();

  return (
    <WhiteSection data-testid="marketing-closing">
      <SectionInner>
        <SplitRow>
          <CopyStack>
            <div>
              <Overline>
                {t('pageHostfullyAccounting.marketing.closing.overline')}
              </Overline>
              <SectionHeading>
                {t('pageHostfullyAccounting.marketing.closing.title')}
              </SectionHeading>
            </div>
            <ContactUsButton testId="marketing-contact-us-closing" />
          </CopyStack>
          <SplitImage
            src={closingImage}
            alt={t('pageHostfullyAccounting.marketing.closing.imageAlt')}
            loading="lazy"
          />
        </SplitRow>
      </SectionInner>
    </WhiteSection>
  );
};

export default ClosingSection;
